<app-sidebar>
  <div class="data-request-container">
    <h1>Search</h1>

    <div class="zero-credits-banner" *ngIf="showZeroCreditsBanner" role="status">
      No credits yet — top up to get started.
      <button mat-button color="primary" type="button" (click)="goToAccountTopup()">Account Info</button>
    </div>
    
    <mat-card>
      <mat-card-content>
        <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
          <div class="id-list-section" formArrayName="idNumbers">
            <div *ngFor="let ctrl of idNumbers.controls; let i = index" class="id-row">
              <mat-form-field appearance="outline" class="id-input">
                <mat-label>ID Number {{ i + 1 }}</mat-label>
                <input
                  matInput
                  type="text"
                  [formControlName]="i"
                  placeholder="13-digit South African ID number"
                  (paste)="i === 0 && onIdPaste($event)">
                <mat-hint>13 digits (YYMMDDGSSSCAZ)</mat-hint>
                <mat-error *ngIf="ctrl?.hasError('invalidId')">
                  idNumber is invalid
                </mat-error>
              </mat-form-field>
              <div class="id-row-actions">
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="removeIdField(i)"
                  *ngIf="idNumbers.length > 1">
                  <mat-icon>remove</mat-icon>
                </button>
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  (click)="addIdField()"
                  [disabled]="idNumbers.length >= maxIdNumbers"
                  matTooltip="Add another ID number">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!requestForm.valid || !hasAnyIdNumber || isSubmitting">
            {{ isSubmitting ? 'Creating Request...' : 'Create Request' }}
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</app-sidebar>


